import { action, onCtxAbort, reaction } from '@reatom/framework'

import { delugeIdAtom } from '@root/entities/auth'
import { selectedNetworkAtom } from '@root/entities/network'
import { dependenciesAtom } from '@root/features/shared/dependencies'

import type { Network } from '@root/entities/network'
import type { DelugeId } from '@root/entities/user-short'

type SubParams = { delugeId: DelugeId; network: Network.Network }

const positionSocketSubscriptionReaction = reaction((ctx) => {
  const { mainWebsocket } = ctx.get(dependenciesAtom)

  const delugeId = ctx.spy(delugeIdAtom)
  if (!delugeId) {
    return
  }
  const network = ctx.spy(selectedNetworkAtom)
  const params: SubParams = { delugeId, network }
  mainWebsocket.userPositionsSubscribeAction(ctx, params)
  onCtxAbort(ctx, () => {
    mainWebsocket.userPositionsUnsubscribeAction(ctx, { network, delugeId })
  })
}, 'positionSocketSubscriptionReaction')

export const initializePositionSocketDataAction = action((ctx) => {
  positionSocketSubscriptionReaction(ctx)
}, 'initializePositionSocketDataAction')
